import { faUser } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ListItemText, Stack } from '@mui/material';
import type { ICellRendererParams } from 'ag-grid-community';

import PonduranceIcon from '@/components/PonduranceIcon';
import PonduranceSvgIcon from '@/components/PonduranceSvgIcon';
import StatusChip, { type StatusTypes } from '@/components/StatusChip';
import { PONDURANCE_NAME } from '@/constants/common';
import theme from '@/theme';

export const ticketsStatusRenderer = ({ data }: ICellRendererParams) => {
  const { status_name } = data;

  return <StatusChip status={status_name as StatusTypes} />;
};

export const ticketsOwnerRenderer = ({ data }: ICellRendererParams) => {
  return (
    <Stack direction="row" sx={{ alignItems: 'center' }}>
      <ListItemText
        primary={data.owner_name}
        secondary={data.team_queue}
        sx={{ margin: 0 }}
      />
      <div style={{ lineHeight: 0, paddingLeft: '1rem', paddingRight: '1rem' }}>
        {data.next_action === 'customer' && (
          <FontAwesomeIcon
            icon={faUser}
            size="lg"
            style={{
              color: theme.vars.palette.border.main
            }}
          />
        )}
        {data.next_action === 'pondurance' && (
          <PonduranceSvgIcon fillcolor={theme.vars.palette.border.main} />
        )}
      </div>
    </Stack>
  );
};

export const ticketsCategoryRenderer = ({ data }: ICellRendererParams) => {
  return (
    <ListItemText
      primary={data.category_name || ''}
      secondary={data.ticket_type === 1 ? 'Threat' : 'Service'}
      sx={{ margin: 0 }}
    />
  );
};

export const ticketsAssigneeRenderer = ({ data }: ICellRendererParams) => {
  return (
    <Stack direction="row" spacing={0.25}>
      <ListItemText
        primary={data.assignee?.name || '--'}
        slotProps={{
          primary: {
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '120px',
              display: 'block'
            }
          }
        }}
        sx={{ margin: 0 }}
      />
    </Stack>
  );
};

export const ticketsAuthorRenderer = (
  params: ICellRendererParams,
  userIsInternal: boolean
) => {
  const { data } = params;

  return (
    <Stack
      direction="row"
      sx={{ alignItems: 'center', width: 'fit-content' }}
      spacing={0.25}
    >
      {data.user.internal && <PonduranceIcon />}
      <ListItemText
        primary={
          data.user.internal && !userIsInternal
            ? PONDURANCE_NAME
            : data.user.name
        }
        slotProps={{
          primary: {
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: '120px',
              display: 'block'
            }
          }
        }}
        sx={{ margin: 0 }}
      />
    </Stack>
  );
};
